<template>
    <div>
        <el-card>
            {{ $t('pageNames.pageNotFound') }}
            <GoHome />
        </el-card>
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import GoHome from '@/components/GoHome.vue'

    export default defineComponent({
        components:{
            GoHome
        },
    });
</script>